import { Guarantor } from "js/components/types";
import { AxiosInstance } from "../utils/AxiosInstance";

// export const getGuarantors = async () => {
//   const { data } = await AxiosInstance.get(`/v1/tenants/guarantors`);
//   return data;
// };

export const createGuarantor = async (newGuarantor: Guarantor) => {
  const { data } = await AxiosInstance.post(
    `/v1/tenants/guarantors/`,
    newGuarantor,
  );
  return data;
};

export const updateGuarantor = async (
  beforeUpdateGuarantor: Guarantor,
  guarantorId: string,
  queryParams?: object,
) => {
  const { data } = await AxiosInstance.put(
    `/v1/tenants/guarantors/${guarantorId}`,
    beforeUpdateGuarantor,
    {
      params: queryParams,
    },
  );

  return data;
};
